import React from 'react'
import {Link} from 'react-router-dom'
import { Mixpanel } from '../../../Mixpanel'



const intro=[
    {question:"What is a Cheerbox?",answer:' A Cheerbox is a customized wellness care package to help People Teams better engage with employees when they have a significant life event. '},
    {question:"Who is a Cheerbox for?",answer:"The Cheerbox is currently only offered as a service to  businesses.     "},
 
    {question:"Can I use Cheerbox for Clients/Customers?",answer:`Yes, Cheerboxes are also a useful engagement tool to help sales/marketing teams recover from customer service failures or show customer appreciation. 
    `},
    {question:"Do you offer branding options?",answer:`Yes, the Corporate Branding set up fee is $199/month (paid annually). The minimum amount of Cheerbox Credits required for branding set up is 24 Credits on your first purchase of credits. As you add more credits there will be no Cheerbox credit minimum.
    `},
    {question:"Am I able to track employee or client engagement? ",answer:`Yes, we offer a full dashboard once you sign-up. You can review reasons why an employee needed a cheerbox, track client feedback/retention and more.  `},
    {question:"What is the size of the Cheerbox?",answer:`It is 9x7x4 (Think of a kids Shoebox). And a larger box size is available upon request for orders of 24 Cheerboxes or more. `},

    {question:"What’s inside the Cheerbox?",answer:`Inside each Cheerbox are what we call “happiness tools” to encourage healing, laughter, gratitude, or a motivational boost. Happiness tools are wellness focused products; games, motivational books, healing guides, , delicious superfoods, snacks, stress relief products and a handwritten note. Did we mention confetti? See Cheerbox examples: On Sample Product Page 
    `},
    {question:"What is the turnaround time on an order? ",answer:`For active customers with either credits or an enterprise account the turnaround time is same day or next morning. For larger projects or bulk orders of 50 or more its 2-3 weeks. Expedited bulk orders is an option contact support@Cheerbox.com or your dedicated account manager for more details 
    `},
    {question:"Can I pick what items go in the box specifically? ",answer:`No. Once your Cheerbox has been created, you will receive a summary report of what’s inside the Cheerbox. For bulk orders we provide options.
    `},    
    {question:"Can I order just One Cheerbox? ",answer:`No. The minimum order size is six.`},    

    {question:"Can I send you guys an item to add to the Cheerbox?",answer:`Yes, if the items are related to a bulk order/project. All items (or branded items) are subject to approval. We reserve the right to refuse any item that does not meet our moral and ethical standards.
    `},
    {question:"Do you store items for me that I can have you send out?",answer:`We don't do that. Try a storage company :)`}    

]

const recipients =[

    {question:"How long will it take for recipient to receive the Cheerbox? ",answer:`Because each Cheerbox is customized to order, please allow up to 1-3 business days from time of order to delivery.
    `},
    {question:"Will the recipient know who is sending the Cheerbox?",answer:'Yes'},
    {question:"Will the information (recipients details) I provide on order be shared with the recipient? ",answer:`All recipient details will never be shared or shown to the recipient for any reason.`}
]

const pricing =[


    {question:"How much does a Cheerbox cost?",answer:`The price of the Cheerbox varies based on our package options. <a href='/#/dashboard/credits'>View Packages Options</a>`},
    {question:"What if I am an Organization/Business/HR looking to order a large volume of Cheerboxes for an occasion or event, can you guys do that?",answer:`Yep! We do those all the time:) You can find instructions on bulk orders here: <a href='/#/dashboard/bulk'>Bulk Orders</a>
    `},
    {question:"Do you guys offer volume pricing?  ",answer:`Yes. If you wish to purchase credits beyond what we offer on the credits page please contact us at support@cheerbox.com`}    

]

const shipping =[

    {question:"Can I have the Cheerbox rushed or shipped next day? ",answer:`Yes, if next day shipping is included in your enterprise account. Most Cheerboxes are received within 2-3 days of purchase including Saturdays. 
    `},
    {question:"If I do not know the recipient's address may I have the Cheerbox sent to my address?",answer:' You may have a Cheerbox sent to yourself and hand deliver to recipient.  '},
    {question:"Do you ship internationally?",answer:` We ship internationally using DHL to 220 Countries. Once a Cheerbox leaves the United States we have little control because customs in other countries have their own rules. 
    `}

]

const credits =[
    {question:"What are Credits? ",answer:`Cheerbox credits are prepaid Cheerboxes. We do not currently support one time purchases. Think of credits as a savings on buying Cheerboxes in bulk  ; say 24 that you can send out throughout the year. 1 Credit = 1 Cheerbox.`},
    {question:"Do Cheerbox credits expire?",answer:`We believe in helping companies show more empathy in the workplace, as a result all Cheerboxes credits expire in 365 days. 
    `},
    {question:'Do Cheerbox credits rollover?', answer:`Cheerbox credits rollover for companies who are actively sending Cheerboxes We do not rollover credits for inactive users.`},
    {question: "Why do Cheerbox credits expire?", answer:"We are committed to improving empathy in the workplace, as a result we want companies to use their Cheerboxes to suppor their employees or clients."},
    {question: "Can I add more credits as I need?", answer:" Yes, you can add credits to your account whenever you want. To add more credits to your account go to the  <a href='/#/dashboard/credits'>Add Credits</a> page."},
    {question: "Can anyone in my organization use credits I purchase? ", answer:`You can  authorize other people in your organization to use your credits. You can also set budget and user restrictions.     `},
    {question: "Are credits redeemable for cash? ", answer: `Credits cannot be redeemed for cash or other monetary value. They must be used towards sending Cheerboxes.
    `},

]



class FAQ extends React.Component{


    componentDidMount(){
        Mixpanel.track('FAQ Pageview')
    }

    render(){

    const IntroFaq = intro.map((info,index)=>{
        return(
            <div key={index}>
                <a className="card-header collapsed d-flex align-items-center" data-toggle="collapse" href={"#collapse"+index}>
                    <div className="card-title">{info.question} </div>
                </a>
                <div id={"collapse"+index} className="card-body bg-grey collapse" data-parent="#accordion">
                    <p>
                    {info.answer}
                    </p>
                </div>                
            </div>
        )
    })
    const RecipientsFaq = recipients.map((info,index)=>{
        index=index+10

        return(
            <div key={index}>
                <a className="card-header collapsed d-flex align-items-center" data-toggle="collapse" href={"#collapse"+index}>
                    <div className="card-title">{info.question} </div>
                </a>
                <div id={"collapse"+index} className="card-body bg-grey collapse" data-parent="#accordion">
                    <p>
                    {info.answer}
                    </p>
                </div>                
            </div>
        )
    })


    const PricingFaq = pricing.map((info,index)=>{
        index=index+20

        return(
            <div key={index}>
                <a className="card-header collapsed d-flex align-items-center" data-toggle="collapse" href={"#collapse"+index}>
                    <div className="card-title">{info.question} </div>
                </a>
                <div id={"collapse"+index} className="card-body bg-grey collapse" data-parent="#accordion">
                    <p>
                    <p dangerouslySetInnerHTML={{__html:info.answer}}></p>
                    </p>
                </div>                
            </div>
        )
    })

    const ShippingFaq = shipping.map((info,index)=>{
        index=index+30

        return(
            <div key={index}>
                <a className="card-header collapsed d-flex align-items-center" data-toggle="collapse" href={"#collapse"+index}>
                    <div className="card-title">{info.question} </div>
                </a>
                <div id={"collapse"+index} className="card-body bg-grey collapse" data-parent="#accordion">
                    <p>
                    {info.answer}
                    </p>
                    
                </div>                
            </div>
        )
    })

    const CreditsFaq = credits.map((info,index)=>{
        index=index+40

        return(
            <div key={index}>
                <a className="card-header collapsed d-flex align-items-center" data-toggle="collapse" href={"#collapse"+index}>
                    <div className="card-title">{info.question} </div>
                </a>
                <div id={"collapse"+index} className="card-body bg-grey collapse" data-parent="#accordion">
                    <p>
                    {info.answer}
                    </p>
                </div>                
            </div>
        )
    })

        return(
            <div>
                                        <div className="col-xl-12">
                                            <div className="widget">
                                                <div className="widget-body pt-2">
                                                    <div id="accordion" className="accordion">
                                                        <div className="widget">
                                                            <div className="widget-header no-actions d-flex align-items-center">
                                                                <h2>Introduction</h2>
                                                            </div>
                                                            
                                                            {IntroFaq}
                                                        </div>
                                                        <div className="widget">
                                                            <div className="widget-header no-actions d-flex align-items-center">
                                                                <h2>Pricing </h2>
                                                            </div>
                                                            {PricingFaq}

                                                        </div>
                                                        <div className="widget">
                                                            <div className="widget-header no-actions d-flex align-items-center">
                                                                <h2>Shipping</h2>
                                                            </div>
                                                            {ShippingFaq}

                                                        </div>
                                                        <div className="widget">
                                                            <div className="widget-header no-actions d-flex align-items-center">
                                                                <h2>Credits</h2>
                                                            </div>
                                                            {CreditsFaq}

                                                        </div>                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


            </div>
        )
    }
}

export default FAQ